// Menu links can't use `javascript:` URLs, so any link pointing to `#cookiebot` reopens the consent banner
const initCookiebotLinks = () => {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="#cookiebot"]');
    if (!link) return;

    e.preventDefault();
    window.Cookiebot?.renew();
  });
};

// Runs `callback` once the visitor has answered the consent banner, or right away when
// there is no Cookiebot or the answer was already given. Accept (even partial) and
// decline both fire after the banner has been hidden; neither fires on page load
// while the banner is still waiting for an answer.
const afterCookiebotResponse = (callback) => {
  const cookiebot = window.Cookiebot;
  if (!cookiebot || cookiebot.hasResponse) {
    callback();
    return;
  }

  const controller = new AbortController();
  const onResponse = () => {
    controller.abort();
    callback();
  };
  window.addEventListener('CookiebotOnAccept', onResponse, { signal: controller.signal });
  window.addEventListener('CookiebotOnDecline', onResponse, { signal: controller.signal });
};

export { initCookiebotLinks, afterCookiebotResponse };
